import { render, staticRenderFns } from "./spareStatementList.vue?vue&type=template&id=65a878bc&scoped=true"
import script from "./spareStatementList.vue?vue&type=script&lang=js"
export * from "./spareStatementList.vue?vue&type=script&lang=js"
import style0 from "./spareStatementList.vue?vue&type=style&index=0&id=65a878bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a878bc",
  null
  
)

export default component.exports